import { ICSSInJSStyle, pxToRem } from "@fluentui/react-northstar";

import { useFluentColorScheme } from "../../../shared/theme/useColorScheme";
import { usePlatformTypeContext } from "../../platform-type-provider/PlatformTypeProvider";
interface DeviceStatusDialogBoxStyles {
  headingLabel: ICSSInJSStyle;
  descriptionLabel: ICSSInJSStyle;
  dialogIcon: ICSSInJSStyle;
  closeIcon: ICSSInJSStyle;
  dialogBox: ICSSInJSStyle;
  dialogBoxTrigger: ICSSInJSStyle;
  successIcon: ICSSInJSStyle;
  warningIcon: ICSSInJSStyle;
  hyphenIcon: ICSSInJSStyle;
}

export const useDeviceStatusDialogBoxStyles: () => DeviceStatusDialogBoxStyles =
  () => {
    const { main, white, yellow } = useFluentColorScheme();
    const { isMobile } = usePlatformTypeContext();

    if (isMobile) {
      return {
        headingLabel: {
          maxWidth: "270px",
        },
        descriptionLabel: {
          maxWidth: "315px",
        },
        dialogIcon: {
          position: "static",
        },
        closeIcon: {
          color: white.foreground,
        },
        dialogBox: {
          width: "343px",
          height: "480px",
          backgroundColor: main.background,
          borderRadius: "8px",
        },
        dialogBoxTrigger: {
          cursor: "none",
          backgroundColor: "transparent",
          padding: "0px",
          minWidth: "18px",
          height: "18px",
          width: "18px",
          maxHeight: "20px",
          maxWidth: "20px",
          border: "0px",
          boxShadow: "none",
        },
        successIcon: {
          backgroundColor: "#00B24A",
          color: main.background,
        },
        warningIcon: {
          color: yellow.background,
        },
        hyphenIcon: {
          color: white.foreground,
        },
      };
    } else {
      return {
        headingLabel: {
          maxWidth: "500px",
        },
        descriptionLabel: {
          maxWidth: "500px",
        },
        dialogIcon: {
          position: "static",
        },
        closeIcon: {
          color: white.foreground,
        },
        dialogBox: {
          width: "600px",
          height: "500px",
          padding: pxToRem(20),
          backgroundColor: main.background,
          borderRadius: "8px",
        },
        dialogBoxTrigger: {
          cursor: "pointer",
          backgroundColor: "transparent",
          padding: "0px",
          minWidth: "18px",
          height: "20px",
          width: "20px",
          maxHeight: "20px",
          maxWidth: "20px",
          border: "0px",
          boxShadow: "none",
        },
        successIcon: {
          backgroundColor: "#00B24A",
          color: main.background,
        },
        warningIcon: {
          color: yellow.background,
        },
        hyphenIcon: {
          color: white.foreground,
        },
      };
    }
  };
